import React, { ReactNode, useCallback } from 'react';
import { Toggle } from '@gafe/common-ui';
import merge from 'classnames';

import { formatPriceWithCurrency } from '@/utils/format-price';

import styles from './BlockToggle.module.scss';

export type Props = {
  title: string;
  value: number | null;
  children?: ReactNode;
  isEnabled: boolean;
  hideValue?: boolean;
  setIsEnabled: (isEnabled: boolean) => void;
};

export const BlockToggle = ({
  title,
  value,
  children,
  isEnabled,
  hideValue = false,
  setIsEnabled,
}: Props) => {
  const onToggleClick = useCallback(() => {
    setIsEnabled(!isEnabled);
  }, [isEnabled, setIsEnabled]);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.title_wrapper}>
          <Toggle checked={isEnabled} onClick={onToggleClick} testId="block-toggle" />
          <div>
            <div className={styles.title}>{title}</div>
            {isEnabled && !hideValue && (
              <span className={merge(styles.value, styles.value_mobile)}>
                {formatPriceWithCurrency(value)}
              </span>
            )}
          </div>
        </div>
        {isEnabled && !hideValue && (
          <span className={styles.value}>{formatPriceWithCurrency(value)}</span>
        )}
      </div>
      {isEnabled && children}
    </>
  );
};
